<div class="container">
    <div class="single-column-layout">
        <div class="ws-flex-container-horizontal ws-flex-justify-content-space-between ws-flex-align-items-baseline instance-info-header">
            <div class="float-start"><h1>Instance Settings</h1></div>
            @if (!isEditSettings && !isEditDocumentIntakeAndProcessing) {
                <div class="float-end">
                    @if (!isEditSettings) {
                        <button
                            class="ace-btn has-icon btn-primary"
                            (click)="setEditSettings()">
                            <i class="fa fa-pencil fa-align"></i>
                        </button>
                    }
                </div>
            }
            @if (isEditSettings) {
                <div class="float-end">
                    @if (showSpinnerSettings) {
                        <span>
                            <ws-ace-loader [inline]="true"></ws-ace-loader>Processing...
                        </span>
                    }
                    @if (!showSpinnerSettings) {
                        <button
                            class="ace-btn has-icon btn-primary btn-success"
                            (click)="saveSettings()"
                        >
                            <i class="fa fa-save"></i>
                        </button>
                    }
                    @if (!showSpinnerSettings) {
                        <button
                            class="ace-btn has-icon btn-primary btn-danger"
                            (click)="cancelSettings()"
                        >
                            <i class="fa fa-close" style="color: white"></i>
                        </button>
                    }
                </div>
            }
        </div>
        <div>
            @if (instanceModel) {
                <form name="instanceEditForm">
                    <div class="row">
                        <div class="col-md-4">
                            <label for="instanceName">Name:</label>
                        </div>
                        <div class="col-md-4">
                            @if (!isEditSettings) {
                                <span>{{ instanceModel.instanceName }}</span>
                            }
                            @if (isEditSettings) {
                                <input
                                    id="instanceName"
                                    name="instanceName"
                                    class="form-control"
                                    maxlength="50"
                                    [(ngModel)]="instanceModel.instanceName">
                            }
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <label>
                                Offers Consulting Services
                            </label>
                        </div>
                        <div class="col-md-5">
                            <div class="checkbox" style="margin-top: 0;">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="offersConsultingService"
                                        [(ngModel)]="instanceModel.offersConsultingServices"
                                        [disabled]="!isEditSettings">
                                    Available for others to request consulting services
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <label>
                                IDP Enabled
                            </label>
                        </div>
                        <div class="col-md-5">
                            <div class="checkbox" style="margin-top: 0;">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="documentIntakeIdpEnabled"
                                        [(ngModel)]="instanceModel.documentIntakeIdpEnabled"
                                        [disabled]="!isEditSettings">
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <label>Main company:</label>
                        </div>
                        <div class="col-md-4">
                            @if (!isEditSettings) {
                                <span>{{ instanceModel.customerCompanyName }}</span>
                            }
                            @if (isEditSettings) {
                                <company-picker
                                    [topLevelOnly]="true"
                                    [company]="companyModel"
                                    [instanceIdFilter]="instanceId"
                                    [activeOnly]="true"
                                    (companySelected)="companySelected($event)">
                                </company-picker>
                            }
                        </div>
                    </div>
                </form>
            }
        </div>

        @if (showDocumentIntakeAndProcessingPanel) {
            <div class="ws-flex-container-horizontal ws-flex-justify-content-space-between ws-flex-align-items-baseline instance-info-header"
                 style="padding-top: 50px;"
            >
                <div class="float-start">
                    <h1>Document Intake & Processing Services</h1>
                </div>
                @if (!isEditDocumentIntakeAndProcessing && !isEditSettings) {
                    <div class="float-end">
                        @if (!isEditDocumentIntakeAndProcessing) {
                            <button
                                class="ace-btn has-icon btn-primary "
                                (click)="setEditDocumentIntakeAndProcessing()">
                                <i class="fa fa-pencil fa-align"></i>
                            </button>
                        }
                    </div>
                }
                @if (isEditDocumentIntakeAndProcessing) {
                    <div class="float-end">
                        @if (showSpinnerDocumentIntakeAndProcessing) {
                            <span>
                                <ws-ace-loader [inline]="true"></ws-ace-loader>Processing...
                            </span>
                        }
                        @if (!showSpinnerDocumentIntakeAndProcessing) {
                            <button
                                class="ace-btn has-icon btn-primary btn-success"
                                (click)="saveDocumentIntakeAndProcessing()"
                                [disabled]="!canSaveDocumentIntakeAndProcessingSettings">
                                <i class="fa fa-save"></i>
                            </button>
                        }
                        @if (!showSpinnerDocumentIntakeAndProcessing) {
                            <button
                                class="ace-btn has-icon btn-primary btn-danger"
                                (click)="cancelDocumentIntakeAndProcessing()">
                                <i class="fa fa-close" style="color: white"></i>
                            </button>
                        }
                    </div>
                }
            </div>
        }
        @if (showDocumentIntakeAndProcessingPanel) {
            <div>
                <form name="documentIntakeAndProcessingForm">
                    <div class="row">
                        <div class="col-md-4">
                            <label for="instanceName">Document Intake & Processing:</label>
                        </div>
                        <div class="col-md-8">
                            <div class="checkbox">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="documentIntakeAndProcessingAssignToRyan"
                                        [ngModel]="instanceModel.documentIntakeAndProcessingAssignToRyan"
                                        (change)="assignToRyanChanged($event)"
                                        [disabled]="!isEditDocumentIntakeAndProcessing">
                                    Assign to Ryan
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <label>Contact</label>
                        </div>
                        <div class="col-md-6">
                            @if (!isEditDocumentIntakeAndProcessing) {
                                <span>{{ selectedUserName }}</span>
                            }
                            @if (isEditDocumentIntakeAndProcessing) {
                                <user-team-picker
                                    [parentUsers]="users"
                                    [(user)]="selectedUser"
                                    (userChange)="userChosen($event)"
                                    [required]="true">
                                </user-team-picker>
                            }
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <label>Special Instructions:</label>
                        </div>
                        <div class="col-md-6">
                            @if (!isEditDocumentIntakeAndProcessing) {
                                <span>
                                    {{ instanceModel.documentIntakeAndProcessingClientSpecialInstructions }}
                                </span>
                            }
                            @if (isEditDocumentIntakeAndProcessing) {
                                <textarea
                                    name="documentIntakeAndProcessingSpecialInstructions"
                                    maxlength="500"
                                    rows="5"
                                    [(ngModel)]="instanceModel.documentIntakeAndProcessingClientSpecialInstructions">
                      </textarea>
                            }
                        </div>
                    </div>
                </form>
            </div>
        }
    </div>
</div>
